import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { MarketPlaceItem } from '../../interfaces/market-place-item.interface';
import { LinkEditInfoModalComponent } from '../link-edit-info-modal/link-edit-info-modal.component';
import { LinkJoblogSearchAdminComponent } from '../link-joblog-searcher-admin/link-joblog-search-admin/link-joblog-search-admin.component';
import {
  NgIf,
  NgClass,
  NgForOf,
  NgStyle,
  DatePipe,
  AsyncPipe,
} from '@angular/common';
import { AsamcoUserService } from '@asamco/base';
import { LinkEditSupportFreshdeskAdminComponent } from './link-edit-support-freshdesk-admin/link-edit-support-freshdesk-admin.component';
import { Link } from '../../interfaces/link.interface';
import { FreshdeskHelpModalComponent, FreshdeskSolutionService, FreshdeskSolutionViewerComponent, LinkInformationFreshdeskArticle } from '@asamco/application-link/shared';

@Component({
  selector: 'al-link-edit-support',
  templateUrl: './link-edit-support.component.html',
  styleUrls: ['./link-edit-support.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgIf,
    LinkEditInfoModalComponent,
    LinkJoblogSearchAdminComponent,
    NgClass,
    NgForOf,
    NgStyle,
    FreshdeskSolutionViewerComponent,
    LinkEditSupportFreshdeskAdminComponent,
    DatePipe,
    AsyncPipe,
    FreshdeskHelpModalComponent,
  ],
})
export class LinkEditSupportComponent implements OnInit, OnDestroy {
  @Input() linkInfo: MarketPlaceItem;

  @Input()
  link: Link;

  @ViewChild(LinkEditSupportFreshdeskAdminComponent)
  linkEditSupportFreshdeskAdminComponent!: LinkEditSupportFreshdeskAdminComponent;

  @ViewChild('helpModal')
  helpModal!: FreshdeskHelpModalComponent;

	public readonly canManageApplicationLinkAdministrationSubject = new Subject<boolean>();
	public readonly canManageApplicationLinkAdministration$ = this.canManageApplicationLinkAdministrationSubject.asObservable();

  articles: LinkInformationFreshdeskArticle[] = [];

  private destroy$ = new Subject<void>();

  constructor(
    private freshdeskSolutionService: FreshdeskSolutionService,
    private cdr: ChangeDetectorRef,
    private asamcoUserService: AsamcoUserService
  ) { }

	ngOnInit(): void {
		this.asamcoUserService.hasAssignedPermission('AL3_ADMINISTRATION').then(result => {
			this.canManageApplicationLinkAdministrationSubject.next(result);
			this.cdr.markForCheck();
		});

    const linkId = this.link?.id;
    if (!linkId) return;

    this.freshdeskSolutionService
      .getLinkInformationArticles(linkId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(articles => {
        this.articles =
          (articles ?? []).sort((a, b) => (a.index > b.index ? 1 : -1)) || [];

        // ✅ Open inline help by default (no button)
        const ids = (this.articles ?? [])
          .map(a => Number(a.articleId))
          .filter(Boolean);

        const origin = {
          kind: 'link_support' as const,
          linkId: this.link?.id ?? null,
        };

        // Avoid timing issues if ViewChild isn't ready at exact emission time
        queueMicrotask(() => {
          if (this.helpModal) {
            this.helpModal.open('Support', ids, origin);
          }
        });

        this.cdr.markForCheck();
      });
  }

  openAdminPanel(): void {
    if (!this.linkInfo?.id) return;
    this.linkEditSupportFreshdeskAdminComponent.open(this.link.id);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
